var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "groupby-container" },
      [
        _c("SelectPicker", {
          staticClass: "groupselect",
          attrs: {
            allowHtml: "",
            allowUnknownValues: "",
            "data-class": "btn-sm btn-default",
            "data-width": "275px",
            "data-menu-width": "grow",
            "data-style": {
              borderTopRightRadius: _vm.contextEnabled ? 0 : undefined,
              borderBottomRightRadius: _vm.contextEnabled ? 0 : undefined,
              borderRightWidth: _vm.contextEnabled ? 0 : undefined,
            },
            placeholder: "Group " + _vm.type + " by...",
            searchable:
              _vm.normalGroupByOptions.flatMap(function (o) {
                return o.options ? o.options : o
              }).length > 12,
            disabled: _vm.disabled,
            options: _vm.normalGroupByOptions,
          },
          model: {
            value: _vm.groupBy,
            callback: function ($$v) {
              _vm.groupBy = $$v
            },
            expression: "groupBy",
          },
        }),
        _vm._v(" "),
        _vm.contextEnabled
          ? _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary",
                staticStyle: {
                  "border-top-left-radius": "0",
                  "border-bottom-left-radius": "0",
                },
                attrs: { type: "button", disabled: _vm.disabled },
                on: { click: _vm.submitContext },
              },
              [_vm._v("Apply")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.groupBy && !_vm.contextEnabled
          ? _c(
              "div",
              {
                class: ["checkbox-inline", { disabled: _vm.disabled }],
                staticStyle: { "margin-left": "5px" },
              },
              [
                _c(
                  "label",
                  {
                    staticStyle: {
                      "white-space": "nowrap",
                      margin: "0",
                      cursor: "pointer",
                    },
                    attrs: {
                      title: "Separate groups for differently cased values",
                      for: _vm.uid + "case",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.caseSensitive,
                          expression: "caseSensitive",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: _vm.uid + "case",
                        disabled: _vm.disabled,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.caseSensitive)
                          ? _vm._i(_vm.caseSensitive, null) > -1
                          : _vm.caseSensitive,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.caseSensitive,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.caseSensitive = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.caseSensitive = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.caseSensitive = $$c
                          }
                        },
                      },
                    }),
                    _vm._v("Case-sensitive\n\t\t\t"),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.viewGroup
      ? _c("div", { staticStyle: { color: "#888", "font-size": "85%" } }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: { type: "button", disabled: _vm.disabled },
              on: {
                click: function ($event) {
                  return _vm.$emit("viewgroupLeave")
                },
              },
            },
            [
              _c("span", { staticClass: "fa fa-angle-double-right" }),
              _vm._v(" Go back to grouped view"),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.contextEnabled
      ? _c(
          "div",
          { staticClass: "groupby-context-container" },
          [
            _vm._l(_vm.unappliedContextGroups, function (group, index) {
              return _c("ContextGroup", {
                key: index,
                on: {
                  delete: function ($event) {
                    return _vm.deleteContextGroup(index)
                  },
                },
                model: {
                  value: _vm.unappliedContextGroups[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.unappliedContextGroups, index, $$v)
                  },
                  expression: "unappliedContextGroups[index]",
                },
              })
            }),
            _vm._v(" "),
            _vm.contextSupported
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.createContextGroup },
                  },
                  [_vm._v("New context group")]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }